export default [
    "#EE7163",
    '#F4AD5F',
    '#F9D76B',
    '#82D378',
    '#5A95F8',
    '#B67BDF',
    '#A5A5A8'
];
